var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"todo"},[(_vm.visible)?_c('line-chart',{attrs:{"receta":_vm.trabajoCargado.detalles,"setpointMaximo":_vm.setpointMaximo,"chartData":_vm.datosGrafico}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }